<div id="port-airport"></div>
<app-admin-dashboard>
  <div class="card">
    <p-breadcrumb
      class="w-full breadcrumb-style"
      [home]="breadcrumbHome"/>

    <div class="header-card pt-0">
      <div class="w-12 container-title">
        <h1 class="text-xl font-medium text-800 m-0">
          {{'PortAirportPage.PageTitle' | translate}}
        </h1>
      </div>
    </div>

    <div class="body-card mt-3">
      <p-selectButton
        [options]="typeOptions"
        [(ngModel)]="selectedType"
        optionLabel="label"
        optionValue="value"
        (onChange)="onTypeChange()">
      </p-selectButton>
      <form [formGroup]="formGroup">
        <div class="flex flex-wrap flex-column justify-content-center align-items-center">
          <div class="w-full md:w-5 p-fluid formgrid grid">

            <div class="field col-12 xl:col-6">
              <label for="name">
                {{'PortAirportPage.NameFieldLabel' | translate }}
                <span class="mandatory-field">*</span>
              </label>
              <input
                id="name"
                formControlName="name"
                type="text"
                maxlength="120"
                required
                pInputText
                placeholder="{{'PortAirportPage.NameFieldPlaceholder' | translate }}"
                class="custom-input"/>
              <small *ngIf="submit && formGroup.controls['name'].invalid" class="p-error">{{getErrorMessage('name')}}</small>
            </div>

            <div class="field col-12 xl:col-6">
              <label for="countryId">
                {{'PortAirportPage.CountryFieldLabel' | translate }}
                <span class="mandatory-field">*</span>
              </label>
              <p-dropdown id="countryId"
                formControlName="countryId"
                [options]="countries"
                optionLabel="name"
                optionValue="id"
                [filter]="true"
                filterBy="name"
                [showClear]="true"
                class="custom-dropdown"
                placeholder="{{'PortAirportPage.CountryFieldPlaceholder' | translate}}">
              </p-dropdown>
              <small *ngIf="submit && formGroup.controls['countryId'].invalid" class="p-error">{{getErrorMessage('countryId')}}</small>
            </div>

            <div class="field col-12 xl:col-6" style="margin-bottom: 20px;">
              <label for="locode">
                {{'PortAirportPage.LocodeFieldLabel' | translate }}
                <span class="mandatory-field">*</span>
              </label>
              <input
                id="locode"
                formControlName="locode"
                type="text"
                maxlength="50"
                required
                pInputText
                placeholder="{{'PortAirportPage.LocodeFieldPlaceholder' | translate }}"
                class="custom-input"/>
              <small *ngIf="submit && formGroup.controls['locode'].invalid" class="p-error">{{getErrorMessage('locode')}}</small>
            </div>


            <div *ngIf="selectedType === 'port'" class="field col-12 xl:col-6">
              <label for="latitude">
                {{'PortAirportPage.LatitudeFieldLabel' | translate }}
              </label>
              <input
                id="latitude"
                formControlName="latitude"
                type="text"
                placeholder="{{'PortAirportPage.LatitudeFieldPlaceholder' | translate }}"
                class="custom-input"
                pInputText/>
            </div>

            <div *ngIf="selectedType === 'port'" class="field col-6 xl:col-6">
              <label for="longitude">
                {{'PortAirportPage.LongitudeFieldLabel' | translate }}
              </label>
              <input
                id="longitude"
                formControlName="longitude"
                type="text"
                placeholder="{{'PortAirportPage.LongitudeFieldPlaceholder' | translate }}"
                class="custom-input"
                pInputText/>
            </div>

            <div class="field col-12" style="margin-bottom: 20px;">
              <div class="w-full">
                <p-button
                  (onClick)="submitForm()"
                  [loading]="loading"
                  label="{{'PortAirportPage.CreateButton' | translate}}"
                  styleClass="p-button-primary"
                  class="custom-text-button"/>
              </div>
            </div>
          </div>

        </div>
      </form>

      <div *ngIf="selectedType === 'port'">
        <div class="mt-4">
          <p-table
            #tablePorts
            [value]="ports"
            [paginator]="true"
            class="custom-table"
            [lazy]="true"
            (onLazyLoad)="getPortsPaged($event)"
            [rows]="pageSizePorts"
            [totalRecords]="totalCountPorts"
            [loading]="loading"
            class="custom-table bg-header mt-4"
            >
            <ng-template pTemplate="header">
                <tr>
                    <th>
                        <div class="flex justify-content-center align-items-center pl-space-table">
                            {{'PortAirportPage.IdColumn' | translate}}
                        </div>
                    </th>
                    <th>
                        <div class="flex align-items-center">
                            {{'PortAirportPage.NameFieldLabel' | translate}}
                        </div>
                    </th>
                    <th>
                        <div class="flex align-items-center">
                            {{'PortAirportPage.LocodeFieldLabel' | translate}}
                        </div>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-port>
                <tr>
                    <td>
                        <div class="flex justify-content-center align-items-center pl-space-table">
                            <span>{{port.id}}</span>
                        </div>
                    </td>
                    <td>
                        <div class="flex align-items-center">
                            <span>{{port.name}}</span>
                        </div>
                    </td>
                    <td>
                        <div class="flex align-items-center">
                            <span>{{port.locode}}</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
          </p-table>
        </div>
      </div>

      <div *ngIf="selectedType === 'airport'">
        <div class="mt-4">
          <p-table
            #tableAirports
            [value]="airports"
            [paginator]="true"
            class="custom-table"
            [lazy]="true"
            (onLazyLoad)="getAirportsPaged($event)"
            [rows]="pageSizeAirports"
            [totalRecords]="totalCountAirports"
            [loading]="loading"
            class="custom-table bg-header mt-4"
            >
            <ng-template pTemplate="header">
                <tr>
                    <th>
                        <div class="flex justify-content-center align-items-center pl-space-table">
                            {{'PortAirportPage.IdColumn' | translate}}
                            <p-columnFilter type="text" field="id" display="menu" [showAddButton]="false" [showMatchModes]="false" [showOperator]="false"></p-columnFilter>
                        </div>
                    </th>
                    <th>
                        <div class="flex align-items-center">
                            {{'PortAirportPage.NameFieldLabel' | translate}}
                            <p-columnFilter
                              type="text"
                              [field]="profile?.lang === 'en' ? 'name' : 'nameEs'"
                              display="menu"
                              [showAddButton]="false"
                              [showMatchModes]="false"
                              [showOperator]="false"
                              matchMode="contains"></p-columnFilter>
                        </div>
                    </th>
                    <th>
                        <div class="flex align-items-center">
                            {{'PortAirportPage.LocodeFieldLabel' | translate}}
                        </div>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-airport>
                <tr>
                    <td>
                        <div class="flex justify-content-center align-items-center pl-space-table">
                            <span>{{airport.id}}</span>
                        </div>
                    </td>
                    <td>
                        <div class="flex align-items-center">
                            <span>{{airport.name}}</span>
                        </div>
                    </td>
                    <td>
                        <div class="flex align-items-center">
                            <span>{{airport.locode}}</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>

  </div>
</app-admin-dashboard>
